import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import heroImage from "../images/hero-image.png";
import digitalBoard from "../images/services/digiboard.jpg";
import threeDBillboards from "../images/services/3d-billboards.jpg";
import generalPrinting from "../images/services/general printing services.jpg";
import customTshirt from "../images/services/t-shirt-customization.png";
import cards from "../images/services/invitation_brochures_magazines.avif";
import invoice from "../images/services/invoice.webp";
import receipt from "../images/services/receipt.webp";
import frames from "../images/services/picture frames.webp";


const Services = () => {

    
    return (
        <div>
            <nav>
                <Navbar />
            </nav>
            <section className=" p-2 overflow-hidden bg-cover bg-center h-screen flex flex-col justify-center items-center text-center text-white" style={{ backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${heroImage})` }}>
                <h1 className="text-5xl font-bold mb-4">Welcome to Our Services</h1>
                <p className="text-xl mb-8">We provide top-notch services to meet your needs. Let us help you achieve your goals.</p>
                <div className="">
                    <button className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded mr-4">Hire Us</button>
                    <button className="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded">Make Enquiries</button>
                </div>
            </section>
            <section className="min-h-screen">
                <div className="rounded-lg shadow-black shadow-lg ring-4 ring-yellow-400 w-[350px]  h-[400px] mx-auto my-10 p-4 ">
                    <figure className="flex flex-col">
                        <img src={digitalBoard} alt="digital bill board with the inscription led sign board" className="rounded-lg "/>
                        <figcaption className="font-semibold text-2xl text-center mt-[30px] text-blue-700">Digital Sign Board Design & Installation</figcaption>
                    </figure>
                </div>
                <div className="rounded-lg shadow-black shadow-lg ring-4 ring-yellow-400 w-[350px]  h-[400px] mx-auto my-10 p-4 ">
                    <figure className="flex flex-col">
                        <img src={generalPrinting} alt="a collection of general printing items" className="rounded-lg ring-2 ring-green-600 shadow-md shadow-black"/>
                        <figcaption className="font-semibold text-2xl text-center mt-[30px] text-blue-700">General Printing</figcaption>
                    </figure>
                </div>
                <div className="rounded-lg shadow-black shadow-lg ring-4 ring-yellow-400 w-[350px]  h-[400px] mx-auto my-10 p-4 ">
                    <figure className="flex flex-col">
                        <img src={customTshirt} alt="three black and white customized t-shirts" className="rounded-lg ring-2 ring-red-600 shadow-md shadow-red-300"/>
                        <figcaption className="font-semibold text-2xl text-center mt-[30px] text-blue-700">T-shirt Customization</figcaption>
                    </figure>
                </div>
                <div className="rounded-lg shadow-black shadow-lg ring-4 ring-yellow-400 w-[350px]  h-[400px] mx-auto my-10 p-4 ">
                    <figure className="flex flex-col">
                        <img src={cards} alt="three black and white customized t-shirts" className="rounded-lg ring-2 ring-violet-600 shadow-md shadow-violet-300"/>
                        <figcaption className="font-semibold text-2xl text-center mt-[30px] text-blue-700">Invitation Cards, Brochures & Magazines</figcaption>
                    </figure>
                </div>
                <div className="rounded-lg shadow-black shadow-lg ring-4 ring-yellow-400 w-[350px]  h-full mx-auto my-10 p-4 ">
                    <figure className="flex flex-col">
                        <div className="flex flex-col items-center">
                        <img src={invoice} alt="three black and white customized t-shirts" className="rounded-lg ring-2 ring-pink-600 shadow-md shadow-red-300 w-full"/>
                        <img src={receipt} alt="three black and white customized t-shirts" className="rounded-lg ring-2 ring-pink-600 shadow-md shadow-red-300 w-full mt-5"/>
                        </div>
                        
                        <figcaption className="font-semibold text-2xl text-center mt-[30px] text-blue-700">Invoice, Receipt & Way Bills</figcaption>
                    </figure>
                </div>

                <div className="rounded-lg shadow-black shadow-lg ring-4 ring-yellow-400 w-[350px]  h-[400px] mx-auto my-10 p-4 ">
                    <figure className="flex flex-col">
                        <img src={threeDBillboards} alt="a collection of general printing items" className="rounded-lg ring-2 ring-orange-600 shadow-md shadow-orange-300"/>
                        <figcaption className="font-semibold text-2xl text-center mt-[30px] text-blue-700">Bill Boards, 3D, 2D & Installation</figcaption>
                    </figure>
                </div>
                <div className="rounded-lg shadow-black shadow-lg ring-4 ring-yellow-400 w-[350px]  h-full  mx-auto my-10 p-4 ">
                    <figure className="flex flex-col">
                        <img src={frames} alt="a collection of picture frames" className="rounded-lg ring-2 ring-green-600 shadow-md shadow-green-300 "/>
                        <figcaption className="font-semibold text-2xl text-center mt-[30px] text-blue-700">Picture Frames</figcaption>
                    </figure>
                </div>
                

            </section>
            <section>
                <Footer />
            </section>


        </div>
    )
}

export default Services;